import styled from 'styled-components';
import styles from '@components/utils/styles';
import { GatsbyImage } from 'gatsby-plugin-image';

export const Categories = styled.div`
  @media (min-width: 768px) {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    gap: 1rem;
    justify-content: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  margin-bottom: 2rem;

  .categoryLink {
    @media (min-width: 768px) {
      display: flex;
      width: 24%;
    }
    width: 100%;
    text-decoration: none;
  }
`;
export const CategoryItem = styled.div`
  @media (min-width: 768px) {
    display: flex;
    flex-direction: column;
    background: white;
    align-items: center;
  }
  width: 100%;
  border-radius: 0 0 4px 4px;

  .categoryTitle {
    @media (min-width: 768px) {
      background: ${styles.colors.blue[1000]};
      color: white;
      width: 100%;
      font-size: 1.125rem;
      padding: 0.75rem 0.25rem;
      text-align: center;
      border-radius: 4px 4px 0 0;
    }
    background: ${styles.colors.blue[1000]};
    display: block;
    color: white;
    width: 95%;
    text-decoration: none;
    font-size: 1.125rem;
    padding: 0.75rem 0.25rem;
    text-align: center;
    border-radius: 4px 4px 0 0;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
`;

export const CategoryImage = styled(GatsbyImage)`
  @media (min-width: 768px) {
    margin: auto;
    max-height: 100%;
    height: 100%;
    width: 100%;
    max-width: 100%;
    object-fit: contain;
  }
  height: 95%;
  width: 95%;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 0 0 4px 4px;
`;
